import React from 'react';
import { Box, Group, Kbd, Text, rem } from '@mantine/core';
import { Spotlight } from '@mantine/spotlight';
import { IconChevronRight } from '@tabler/icons-react';
import type { Icon } from '@tabler/icons-react';

type Props = {
    icon: Icon;
    label: string;
    hint?: string;
    trail?: string[];
    branchId?: string;
    onSelect: () => void;
    closeOnSelect: boolean;
    tone?: 'brand' | 'neutral';
};

const SpotlightRow: React.FC<Props> = ({ icon: Icon, label, hint, trail, branchId, onSelect, closeOnSelect, tone = 'neutral' }) => (
    <Spotlight.Action
        onClick={onSelect}
        closeSpotlightOnTrigger={closeOnSelect}
        data-branch-id={branchId}
        aria-label={trail?.length ? `${trail.join(', ')}, ${label}` : label}
        style={{ padding: `${rem(8)} ${rem(12)}`, borderRadius: 'var(--mantine-radius-md)' }}
    >
        <Group gap="sm" wrap="nowrap" style={{ width: '100%', minWidth: 0 }}>
            <Box
                aria-hidden
                style={{
                    display: 'grid', placeItems: 'center', flexShrink: 0,
                    width: rem(34), height: rem(34), borderRadius: rem(9),
                    backgroundColor: tone === 'brand' ? 'var(--bd-brand-soft)' : 'var(--bd-surface-sunken)',
                    color: tone === 'brand' ? 'var(--bd-brand-text)' : 'var(--mantine-color-text)',
                    border: '1px solid var(--bd-border)',
                }}
            >
                <Icon size={18} stroke={1.7} />
            </Box>

            <Box style={{ flex: 1, minWidth: 0 }}>
                {trail && trail.length > 0 ? (
                    <Text size="xs" c="dimmed" truncate style={{ lineHeight: 1.3 }}>
                        {trail.join(' › ')}
                        <Text component="span" size="xs" c="dimmed" style={{ opacity: 0.6 }}> ›</Text>
                    </Text>
                ) : null}
                <Text size="sm" fw={600} truncate style={{ color: 'var(--bd-text-strong)', lineHeight: 1.35 }}>{label}</Text>
                {hint ? <Text size="xs" c="dimmed" truncate style={{ lineHeight: 1.35 }}>{hint}</Text> : null}
            </Box>

            <Box aria-hidden style={{ flexShrink: 0, display: 'flex', alignItems: 'center', color: 'var(--mantine-color-dimmed)' }}>
                {branchId ? <IconChevronRight size={16} stroke={2} /> : <Kbd size="xs">↵</Kbd>}
            </Box>
        </Group>
    </Spotlight.Action>
);

export default SpotlightRow;
